import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useProfileQuery } from 'src/modules/myProfile/src/profileQueries';
import WelcomeLine from '../../../components/WelcomeLine';
import ROUTE_NAME from '../../../routes/RouteName';
import { parseDateTimeISO } from '../../../utils/dateHelper';
import {
    getTransactionData,
    getTransactionSummary,
} from '../src/transactionApis';
import Filtering from './Filtering';
import ListTransaction from './ListTransaction';
import TransactionDashboard from './TransactionDashboard';

const Transaction = () => {
    const navigate = useNavigate();

    const [transactionData, setTransactionData] = useState([]);
    const [transactionSummary, setTransactionSummary] = useState();
    const [isFetching, setIsFetching] = useState(false);
    const [isFetchingTransactionData, setIsFetchingTransactionData] = useState(false);
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [cashflowTypeSlugs, setCashflowTypeSlugs] = useState([]);

    const { data: profileData } = useProfileQuery();

    const handleGetTransactionData = (response) => {
        const { data: responseData, current_page: currentPage, last_page: totalPages, total: investmentNoteCount } = response.data;

        responseData.forEach(item => {
            if (item.created_at) {
                item.created_at = parseDateTimeISO(item.created_at, 'dd MMM yyyy h:mm a');
            }
        });

        setTransactionData(responseData);
        setPage(currentPage);
        setPageCount(totalPages);
    };

    const handleGetTransactionSummary = (response) => {
        const { data: responseData } = response.data;
        setTransactionSummary(responseData);
    };

    useEffect(() => {
        setIsFetching(true);
        getTransactionSummary(handleGetTransactionSummary);
        setIsFetching(false);
    }, []);

    useEffect(() => {
        async function fetchData() {
            setIsFetchingTransactionData(true);

            window.scrollTo(0, 0);

            window.history.replaceState({}, document.title, window.location.pathname);

            var paramsDict = {};
            paramsDict['filter[cashflowType.slug][]'] = cashflowTypeSlugs;

            let queryString = `page=${page}`;

            queryString += `&${cashflowTypeSlugs
                .map((param) => `filter[cashflowType.slug][]=${param}`)
                .join('&')}`;

            await getTransactionData(page, paramsDict, handleGetTransactionData);

            setIsFetchingTransactionData(false);
            navigate(`${ROUTE_NAME.TRANSACTION}?${queryString}`);
        }

        fetchData();
    }, [page, cashflowTypeSlugs]);

    const filterTransactionData = (values) => {
        const sortedCashflowTypes = [...values.transactionTypeSlugs].sort((a, b) => a - b);

        setCashflowTypeSlugs(sortedCashflowTypes);
        setPage(1);
    };

    return (
        <div className="page-wrapper">
            <div className="dashboard-section container">
                <WelcomeLine name={profileData?.first_name || 'N/A'} />
                <div className="transaction__summary-container">
                    <TransactionDashboard
                        transactionSummaryData={transactionSummary}
                        isFetching={isFetching}
                    />
                </div>
            </div>
            <div className="transaction__listing container">
                <Filtering
                    filterTransactionData={filterTransactionData}
                    isFetching={isFetching}
                />
                <ListTransaction
                    transactionFilter={transactionData}
                    page={page}
                    setPage={setPage}
                    pageCount={pageCount}
                    isFetching={isFetchingTransactionData}
                />
            </div>
        </div>
    );
};

export default Transaction;
